import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {ListLoader} from "../../components/ListLoader";
import {Util} from "../../components/Util";
import {Copy} from "react-bootstrap-icons";

export class ListLinguisticValues extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return '/linguistic-values/list';
    }

    protected navigate(event: any) {
        if (event.target.classList.contains('copy') || event.target.closest('a') || event.target.closest('.copy')) {
            return;
        }
        event.preventDefault();

        const key = event.target.closest('tr').getAttribute('data-key');
        const namespace = event.target.closest('tr').getAttribute('data-namespace');

        super.navigate(event, '/linguistic-values/edit/' + namespace + '/' + key);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const navigate = this.navigate,
            params: {} | any = this.getFormData();

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>

                            <div className="col-lg-3 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="key" className="form-label">{this.dictionary.get['key']}</label>
                                    <input type="text" className="form-control form-control-sm"
                                           id="key"
                                           name="key"
                                           defaultValue={params.key ?? ''}/>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="value" className="form-label">{this.dictionary.get['value']}</label>
                                    <input type="text" className="form-control form-control-sm"
                                           id="value"
                                           name="value"
                                           defaultValue={params.value ?? ''}/>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="created_by"
                                           className="form-label">{this.dictionary.get['created_by']}</label>
                                    <input type="text" className="form-control form-control-sm"
                                           id="created_by"
                                           name="created_by"
                                           defaultValue={params.created_by ?? ''}/>
                                </div>
                            </div>


                            <div className="col-lg-3 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="namespace"
                                           className="form-label">{this.dictionary.get['namespace']}</label>
                                    <select className="form-control form-control-sm"
                                            id="namespace"
                                            name="namespace"
                                            defaultValue={params.namespace ?? ''}>
                                        <option value="">{this.dictionary.get['show-all']}</option>
                                        <option value="auth">auth</option>
                                        <option value="frontend">frontend</option>
                                        <option value="backend">backend</option>
                                    </select>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="language"
                                           className="form-label">{this.dictionary.get['language']}</label>
                                    <select className="form-control form-control-sm"
                                            id="language"
                                            name="language"
                                            defaultValue={params.language ?? ''}>
                                        <option value="">{this.dictionary.get['show-all']}</option>
                                        {this.dictionary.handledLanguages.map((elem) => (
                                            <option key={elem} value={elem}>{this.dictionary.get[elem]}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="nullValues"
                                           className="form-label">{this.dictionary.get['null-values']}</label>
                                    <select className="form-control form-control-sm"
                                            id="nullValues"
                                            name="null-values"
                                            defaultValue={params['null-values'] ?? ''}>
                                        <option value="">{this.dictionary.get['show-all']}</option>
                                        <option value="yes">{this.dictionary.get['yes']}</option>
                                        <option value="no">{this.dictionary.get['no']}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'id:d'}/>
                        {this.listOfSearchParams(params)}
                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/linguistic-values/export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['linguistic-values']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>


                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="id">
                                    # <i className="bi bi-sort-down"></i>
                                </th>
                                <th className="sortable" data-sortkey="namespace">
                                    {this.dictionary.get['namespace']}
                                </th>
                                <th className="sortable"
                                    data-sortkey="language">{this.dictionary.get['language']}</th>
                                <th className="sortable" data-sortkey="`key`">{this.dictionary.get['key']}</th>
                                <th className="sortable" data-sortkey="`value`"
                                    colSpan={2}>{this.dictionary.get['value']}</th>
                                <th className="sortable" data-sortkey="created_at">
                                    {this.dictionary.get['created_at']}
                                </th>
                                <th className="sortable" data-sortkey="created_by">
                                    {this.dictionary.get['created_by']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                let createdAt = '-';
                                if (elem.created_at) {
                                    createdAt = (new Date(elem.created_at + ' GMT')).toLocaleString();
                                }
                                return (
                                    <tr key={elem.id} data-key={elem.key} data-namespace={elem.namespace}
                                        onMouseDown={navigate}>
                                        <td style={{textAlign: 'right'}}>{elem.id}</td>
                                        <td>{elem.namespace}</td>
                                        <td>{elem.language}</td>
                                        {Util.copyCell(elem.key)}
                                        <td onClick={Util.copy} className="copy" data-copy={elem.value}
                                            style={{padding: '10px 18px', color: '#3366FF'}}>
                                            <Copy onClick={Util.copy} className="copy" data-copy={elem.value}/>
                                        </td>
                                        <td>{elem.value || '<i class="color-blue">NULL</i>'}</td>
                                        <td>{createdAt}</td>
                                        <td>{elem.created_by ? elem.created_by : '-'}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={7}/>
                            ) : ''}
                        </table>
                    </div>
                </div>

                {this.state.isLoading && <ListLoader/>}
            </>
        );
    }
}
